import { render, staticRenderFns } from "./PersonalInfoCollectContent.vue?vue&type=template&id=c148d7fe&scoped=true"
import script from "./PersonalInfoCollectContent.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCollectContent.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoCollectContent.vue?vue&type=style&index=0&id=c148d7fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c148d7fe",
  null
  
)

export default component.exports